var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.467 3.028V.02l3.4-.02v3.028H24.88v1.55H12.867v2.963h-3.4V4.579H.879v-1.55h8.588ZM.879 11.219h15.487v-2.95l3.393-.019v2.969h5.12v1.55h-5.12v3.022h-3.393v-3.022H.88v-1.55ZM6.021 19.522H.879v1.55H6.02v2.93h3.393v-2.93h15.465v-1.55H9.414V16.46l-3.393.02v3.042Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Filter.0d4cc1bf285ab5df176c341de516bd80.svg";